import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Div100vh from "react-div-100vh";

import { fetchData, updateFunction } from "@/lib/helper";
import { ArrowRight } from "lucide-react";
import ContactScreen from "./ContactScreen";
import Header from "@/components/common/Header/header";
import LoadingSplashScreen from "@/components/onboarding/LoadingSplashScreen";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";

function ReadOnlyInputBox({ label, defaultValue }) {
  return (
    <div className="flex flex-col gap-4">
      <span>{label}</span>
      <input
        type="text"
        value={defaultValue}
        className={`border p-4 text-base border-primary-500 bg-input-bg focus:outline-none w-full text-prima focus-within:border-primary-200 h-full placeholder-transparent peer`}
        readOnly
      />
    </div>
  );
}

export default function InviteAcceptanceScreen() {
  const navigate = useNavigate();

  const [data, setData] = useState({});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [correctReferral, setCorrectReferral] = useState(false);

  const referralCode = localStorage.getItem("LANDLORD_REFERRAL_CODE");

  const fetchInviteData = async () => {
    try {
      setLoading((prevState) => !prevState);
      const response = await fetchData(
        `public/landlord-invite/${referralCode}`
      );
      if (response.success) {
        setData(response.data);
        setCorrectReferral((prevState) => !prevState);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading((prevState) => !prevState);
    }
  };

  useEffect(() => {
    if (referralCode) {
      fetchInviteData();
    }
  }, []);

  const handleButtonClick = async () => {
    try {
      setBtnLoading((prevState) => !prevState);
      await updateFunction({ code: referralCode }, "public/accept-invite");
      fetchInviteData();
    } catch (err) {
      setError(err.message || "Something went wrong!");
    } finally {
      setBtnLoading((prevState) => !prevState);
    }
  };

  if (loading) return <LoadingSplashScreen />;
  else {
    if (correctReferral) {
      if (data.acceptedInvite) return <ContactScreen />;
      else {
        return (
          <Div100vh className="flex flex-col justify-between py-8 px-8">
            <Header customBackSubmit={() => navigate("/platform-charges")} />
            <div className="flex flex-col gap-4">
              <div className="text-[#eeeeee] text-2xl leading-10">
                <span>Congrats, you have been invited by your tenant - </span>
                <span className="font-semibold">{data.tenant_name}.</span>
              </div>
              <span className="text-[#999999] text-xl">
                Please confirm your details
              </span>
            </div>
            {data && (
              <div className="text-[#999999] text-sm flex flex-col gap-8">
                <ReadOnlyInputBox
                  label={"Confirm your name:"}
                  defaultValue={data.landlord_name}
                />
                <ReadOnlyInputBox
                  label={"Confirm your contact number:"}
                  defaultValue={data.landlord_phone}
                />
              </div>
            )}
            <PrimaryButton
              text={"Yes, my details are correct"}
              icon={ArrowRight}
              handleClick={handleButtonClick}
              error={error}
              loading={btnLoading}
            />
          </Div100vh>
        );
      }
    } else {
      return <ContactScreen invalidReferral />;
    }
  }
}
